import { Box } from '@mui/material'
import { MuiTelInput } from 'mui-tel-input'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { InputHeader } from '../Headers/styles'
import RequiredAsterisk from '../RequiredAsterisk/RequiredAsterisk'

type FormPhoneInputProps = {
    name: string
    label: string
    disabled?: boolean
    required?: boolean
    maxLength?: number
}

const FormPhoneInput: React.FC<FormPhoneInputProps> = ({
    name,
    label,
    disabled = false,
    required = false,
    maxLength,
}) => {
    const { control } = useFormContext()

    return (
        <Box mb={2}>
            <Box display='flex' justifyContent='space-between' alignItems='center'>
                <InputHeader gutterBottom>
                    <Box component='span' display='inline-flex' alignItems='baseline'>
                        {label}
                        <Box component='span' visibility={required ? 'visible' : 'hidden'} ml={0.5}>
                            <RequiredAsterisk />
                        </Box>
                    </Box>
                </InputHeader>
            </Box>
            <Controller
                name={name}
                control={control}
                render={({ field, fieldState: { error } }) => (
                    <MuiTelInput
                        fullWidth
                        value={field.value || ''}
                        onChange={(value, info) => {

                            const numberValue = (info.numberValue || '').replace(/[\s+]/g, '')
                            if (!maxLength || numberValue.length <= maxLength) {
                                field.onChange(info.numberValue)
                            }
                        }}
                        disabled={disabled}
                        error={!!error}
                        helperText={error?.message}
                    />
                )}
            />
        </Box>
    )
}

export default FormPhoneInput
